import { Servers } from '../models';
import { AMERICAS_COUNTRY_CODES } from '../constants/regions';
/**
 * Resolves region (EU or US) from ISO 3166-1 alpha-2 country code.
 * Americas -> US Server; rest of world / missing -> EU Server.
 */
export function getRegionByCountryCode(code) {
    var normalized = (code !== null && code !== void 0 ? code : '').trim().toUpperCase();
    if (!normalized) {
        return Servers.europe;
    }
    return AMERICAS_COUNTRY_CODES.includes(normalized)
        ? Servers.america
        : Servers.europe;
}
